import type { PopTone } from '@/types'

// Solid color surfaces with a text color that passes contrast on top of them.
export const TONE_SURFACES: Record<PopTone, string> = {
    primary: 'bg-primary text-primary-foreground',
    blue: 'bg-pop-blue text-background',
    pink: 'bg-pop-pink text-foreground',
    yellow: 'bg-pop-yellow text-foreground',
    mint: 'bg-pop-mint text-foreground',
    lilac: 'bg-pop-lilac text-foreground',
    peach: 'bg-pop-peach text-foreground',
    violet: 'bg-pop-violet text-background'
}

// Background only, for fills that sit behind ink text.
export const TONE_FILLS: Record<PopTone, string> = {
    primary: 'bg-primary',
    blue: 'bg-pop-blue',
    pink: 'bg-pop-pink',
    yellow: 'bg-pop-yellow',
    mint: 'bg-pop-mint',
    lilac: 'bg-pop-lilac',
    peach: 'bg-pop-peach',
    violet: 'bg-pop-violet'
}
